module.exports = __webpack_public_path__ + "49ab5434ada62089c9afabb0ef24f425.svg";